/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteClientSelfieMutationVariables = Types.Exact<{
  [key: string]: never;
}>;
export type DeleteClientSelfieMutation = {
  __typename?: "Mutation";
  clientSelfieDelete?: {
    __typename?: "ClientSelfieDeletePayload";
    result: {
      __typename?: "Client";
      id: string;
    } | {
      __typename?: "ClientSelfieDeleteError";
    };
  } | null;
};
export const DeleteClientSelfieDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "deleteClientSelfie"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "clientSelfieDelete"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "Client"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type DeleteClientSelfieMutationFn = Apollo.MutationFunction<DeleteClientSelfieMutation, DeleteClientSelfieMutationVariables>;

/**
 * __useDeleteClientSelfieMutation__
 *
 * To run a mutation, you first call `useDeleteClientSelfieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientSelfieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientSelfieMutation, { data, loading, error }] = useDeleteClientSelfieMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteClientSelfieMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientSelfieMutation, DeleteClientSelfieMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<DeleteClientSelfieMutation, DeleteClientSelfieMutationVariables>(DeleteClientSelfieDocument, options);
}
export type DeleteClientSelfieMutationHookResult = ReturnType<typeof useDeleteClientSelfieMutation>;
export type DeleteClientSelfieMutationResult = Apollo.MutationResult<DeleteClientSelfieMutation>;
export type DeleteClientSelfieMutationOptions = Apollo.BaseMutationOptions<DeleteClientSelfieMutation, DeleteClientSelfieMutationVariables>;